import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FalLiteRoutingModule } from './fal-lite-routing.module';
import { FalLiteComponent } from './fal-lite.component';
import { SharedModule } from '../../shared/shared.module';
import { FalLiteFiltersContainerComponent } from './components/fal-lite-filter-container/fal-lite-filters-container.component';

@NgModule({
  declarations: [FalLiteComponent, FalLiteFiltersContainerComponent],
  imports: [CommonModule, FalLiteRoutingModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FalLiteModule {}
